<!--<div class="col-lg-12 text-center" *ngIf="getStationDetailLoader" style="margin-top: 50px;">-->
<!--  <img src="/assets/images/load.gif" />-->
<!--</div>-->

<!--<div *ngIf="!getStationDetailLoader" class="panel-group panel-group-control content-group-lg">-->

<!--  <div class="panel" *ngFor="let device of deviceDetails let i = index" [attr.data-index]="i">-->
<!--    <div class="panel-heading">-->
<!--      <h6 class="panel-title">-->
<!--        <a data-toggle="collapse" [ngClass]="{'collapsed': i != 0}" href="#collapsible-control-group{{i}}"><strong>{{device.station_name}} | </strong> <strong class="text-blue-700">{{device.name}}</strong></a>-->
<!--      </h6>-->

<!--      <a [hidden]="(type == 'view')?true:false" class="delicon" (click)="delete(deviceDetails[i]['id'])">-->
<!--        <i class="fa fa-trash" aria-hidden="true" title="Delete Device" style="color: #fff;background: red;padding:7px 8px 8px 8px; font-size:16px;border-radius:16px;cursor: pointer;"></i>-->
<!--      </a>-->

<!--    </div>-->
<!--    <div id="collapsible-control-group{{i}}" [ngClass]="{'in': i == 0}" class="panel-collapse collapse">-->
<!--      <div class="panel-body">-->

<!--        <div class="form-horizontal">-->

<!--          <fieldset class="content-group">-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Device Id*-->
<!--                <div class="text-muted">(as maintained in vendor system)</div>-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" [disabled]="(type == 'view')?true:false" type="text" [(ngModel)]="deviceDetails[i]['name']" placeholder="Enter device Id" class="form-control">-->
<!--                <div *ngIf="formErrorDeviceId[i] && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorDeviceId[i]}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Make-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" [disabled]="(type == 'view')?true:false" type="text" [(ngModel)]="deviceDetails[i]['make_name']" placeholder="Enter device make name" class="form-control">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Model-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" [disabled]="(type == 'view')?true:false" type="text" [(ngModel)]="deviceDetails[i]['model_name']" placeholder="Enter device model" class="form-control">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Serial Number-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" [disabled]="(type == 'view')?true:false" type="email" [(ngModel)]="deviceDetails[i]['actual_serial_no']" placeholder="Enter device serial number" class="form-control">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Certification System Type-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" [disabled]="(type == 'view')?true:false" type="email" [(ngModel)]="deviceDetails[i]['certification']" placeholder="Enter certification system type" class="form-control">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group" *ngIf="type == 'edit'">-->
<!--              <div class="col-lg-12" *ngIf="!updateDeviceLoader">-->

<!--                <div class="col-lg-1 pull-right">-->
<!--                  <button (click)="validateDevice(i)" type="submit" class="btn btn-primary">-->
<!--                    <strong>Update</strong>-->
<!--                  </button>-->
<!--                </div>-->

<!--                <div class="col-lg-1 pull-right">-->
<!--                  <button (click)="getDeviceDetail()" type="button" class="btn btn-danger">-->
<!--                    <strong>Reset</strong>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-lg-12" *ngIf="updateDeviceLoader">-->
<!--                <span class="pull-right"><img style="width: 60%;" src="/assets/images/load.gif" /></span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </fieldset>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--</div>-->
<!--&lt;!&ndash; /collapsible with left control button &ndash;&gt;-->


<div class="text-center py-5" *ngIf="getStationDetailLoader">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div *ngIf="!getStationDetailLoader" class="accordion" id="deviceAccordion">
  <div class="accordion-item mb-3" *ngFor="let device of deviceDetails; let i = index" [attr.data-index]="i">
    <h2 class="accordion-header">
      <button class="accordion-button d-flex justify-content-between align-items-center"
              type="button"
              [ngClass]="{'collapsed': i != 0}"
              [attr.data-bs-target]="'#collapseDevice' + i"
              data-bs-toggle="collapse"
              aria-expanded="i === 0 ? 'true' : 'false'"
              [attr.aria-controls]="'collapseDevice' + i">
        <div>
          <strong>{{device.station_name}} | </strong>
          <strong class="text-primary">{{device.name}}</strong>
        </div>
        <button *ngIf="type !== 'view'"
                class=" btn-danger btn-sm ms-2 fa fa-trash"
                (click)="delete(deviceDetails[i]['id']); $event.stopPropagation()"
                title="Delete Device">
          <i class="bi bi-trash"></i>
        </button>
      </button>
    </h2>
    <div [id]="'collapseDevice' + i"
         class="accordion-collapse collapse"
         [ngClass]="{'show': i == 0}"
         [attr.aria-labelledby]="'headingDevice' + i"
         data-bs-parent="#deviceAccordion">
      <div class="accordion-body">
        <form class="row g-3">
          <div class="col-md-6">
            <label class="form-label">
              Device Id*
              <span class="text-muted d-block">(as maintained in vendor system)</span>
            </label>
            <input autocomplete="off" pattern="^[^<>]*$"
                   [disabled]="type == 'view'"
                   name="deviceId"
                   type="text"
                   [(ngModel)]="deviceDetails[i]['name']"
                   placeholder="Enter device Id"
                   class="form-control">
            <div *ngIf="formErrorDeviceId[i] && error" class="text-danger fw-bold mt-1">
              *{{formErrorDeviceId[i]}}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Make</label>
            <input autocomplete="off" pattern="^[^<>]*$"
                   [disabled]="type == 'view'"
                   type="text"
                   name="make"
                   [(ngModel)]="deviceDetails[i]['make_name']"
                   placeholder="Enter device make name"
                   class="form-control">
          </div>

          <div class="col-md-6">
            <label class="form-label">Model</label>
            <input autocomplete="off" pattern="^[^<>]*$"
                   [disabled]="type == 'view'"
                   type="text"
                   name="model"
                   [(ngModel)]="deviceDetails[i]['model_name']"
                   placeholder="Enter device model"
                   class="form-control">
          </div>

          <div class="col-md-6">
            <label class="form-label">Serial Number</label>
            <input autocomplete="off" pattern="^[^<>]*$"
                   [disabled]="type == 'view'"
                   type="text"
                   name="serialNo"
                   [(ngModel)]="deviceDetails[i]['actual_serial_no']"
                   placeholder="Enter device serial number"
                   class="form-control">
          </div>

          <div class="col-md-6">
            <label class="form-label">Certification System Type</label>
            <input autocomplete="off" pattern="^[^<>]*$"
                   [disabled]="type == 'view'"
                   type="text"
                   name="certification"
                   [(ngModel)]="deviceDetails[i]['certification']"
                   placeholder="Enter certification system type"
                   class="form-control">
          </div>

          <div class="col-12" *ngIf="type == 'edit'">
            <div class="d-flex justify-content-end gap-2">
              <button (click)="getDeviceDetail()" type="button" class="btn btn-danger">
                <strong>Reset</strong>
              </button>
              <button (click)="validateDevice(i)" type="submit" class="btn btn-primary" [disabled]="updateDeviceLoader">
                <span *ngIf="!updateDeviceLoader"><strong>Update</strong></span>
                <span *ngIf="updateDeviceLoader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
